export const videoConstants = {
  GET_VIDEOS: "GET_VIDEOS",
  LOADING: "LOADING",
  ERROR: "ERROR",
  FILTER_CATEGORY: "FILTER_CATEGORY",
  SEARCH: "SEARCH",
  GET_VIDEO: "GET_VIDEO",
};

export const likedConstants = {
  GET_LIKED_VIDEOS: "GET_LIKED_VIDEOS",
  ADD_TO_LIKED: "ADD_TO_LIKED",
  REMOVE_FROM_LIKED: "REMOVE_FROM_LIKED",
};

export const watchLaterConstants = {
  GET_WATCH_LATER_VIDEOS: "GET_WATCH_LATER_VIDEOS",
  ADD_TO_WATCH_LATER: "ADD_TO_WATCH_LATER",
  REMOVE_FROM_WATCH_LATER: "REMOVE_FROM_WATCH_LATER",
};

export const playlistConstants = {
  GET_PLAYLISTS: "GET_PLAYLISTS",
  ADD_PLAYLIST: "ADD_PLAYLIST",
  DELETE_PLAYLIST: "DELETE_PLAYLIST",
  GET_PLAYLIST_BY_ID: "GET_PLAYLIST_BY_ID",
  ADD_VIDEO_TO_PLAYLIST: "ADD_VIDEO_TO_PLAYLIST",
  DELETE_VIDEO_FROM_PLAYLIST: "DELETE_VIDEO_FROM_PLAYLIST",
};

export const historyConstants = {
  GET_HISTORY: "GET_HISTORY",
  CLEAR_HISTORY: "CLEAR_HISTORY",
  ADD_VIDEO_TO_HISTORY: "ADD_VIDEO_TO_HISTORY",
  DELETE_VIDEO_FROM_HISTORY: "DELETE_VIDEO_FROM_HISTORY",
};
